import { SpaceTab as SpaceTabApi } from 'api/space/space-tab';
import { NormalizedData } from 'data/core';
import { dataNormalizer } from 'data/core/utils';
import { spaceTabSchema } from 'data/spaces/schema';
import { Task } from 'data/tasks/schema';

export interface SpaceTab extends Omit<SpaceTabApi, 'space' | 'taskList'> {
  space: number;
  taskList: number[];
}

export type NormalizedSpaceTabData = NormalizedData<SpaceTab>;

interface SpaceTabEntities {
  spaceTabs: NormalizedSpaceTabData | undefined;
  tasks: NormalizedData<Task> | undefined;
}

export const spaceTabNormalizer = (data: SpaceTabApi | SpaceTabApi[]) =>
  dataNormalizer<SpaceTab, SpaceTabEntities, SpaceTabApi>(data, spaceTabSchema);
